export default __webpack_public_path__ + "static/me-7d1f0f0e239d88e42a71b237b4594f62.svg";